import React, { useEffect } from 'react';
import {useSelector} from "react-redux";
import './ToolBar.css';

import Title from "../../components/Title/Title"
import Alert from "../../components/Alert/Alert"
import Room from "./Room/Room"

import PalletColours from './PalletColours/PalletColours';
import OnCanvas from './OnCanvas/OnCanvas';
import { useTranslation } from "react-i18next";


const ToolBar = () => {
  const { t } = useTranslation();
  const isLoggedIn = useSelector(state => state.Feature.isLoggedIn);
  return (
    <div className="acp-Toolbar acp-min-vh-100">
      <div>
        <Title title={t("CONFIG")} />
        {isLoggedIn != 1 && <Alert text={t("Log in to save your objects and pallets.")} />}
        <Room />
      </div>
      <div>
        <PalletColours />
      </div>
      <div>
        <OnCanvas />
      </div>
    </div>
  )
}

export default ToolBar;